import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { NotificationCentre } from '@dbk/ui-icons';
import Badge from '@dbk/ui-badge';
import NotificationModal from '../../../screens/notifications';
import { PALETTE } from '../../../constants';

class NotificationAlert extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
  }

  handlePressed() {
    this.setState((prevState) => ({ selected: !prevState.selected }));
  }

  handleCloseModal() {
    this.setState({ selected: false });
  }

  render() {
    const { onChange, notifications: { userNotifications }, i18n: { messages }, } = this.props;
    const notificationClass =
      userNotifications && userNotifications.totalDisplay > 0
        ? ' '
        : 'margin-left-20';
    const counter = userNotifications && userNotifications.totalDisplay;
    return (
      <div>
        <TouchableOpacity
          id="icon_notification_notificationAlert_test"
          onPress={() => this.handlePressed()}
          accessibilityLabel={messages['app.dash.accessibility.link.notification'] + `${counter}`}
        >
          <span className={'notification-icon-position'}>
            <span className={'badge-position'}>
              {counter > 0 && !this.state.selected && <Badge value={counter} />}
            </span>
            {this.state.selected ? (
              <span className={'margin-left-20'}>
                <NotificationCentre width={24} height={24} color={PALETTE.primaryActive} />
              </span>
            ) : (
              <span className={notificationClass}>
                <NotificationCentre width={24} height={24} color="#999" />
              </span>
            )}
          </span>
        </TouchableOpacity>
        {this.state.selected && (
          <NotificationModal onChange={() => this.handleCloseModal()} />
        )}
      </div>
    );
  }
}

NotificationAlert.propTypes = {
  selected: PropTypes.bool,
  onChange: PropTypes.func,
};

export default createContainer({
  $queries: {
    rsa: {
      onChangePage: { $call: 'changePage' },
    },
    notifications: {
      userNotifications: true,
    },
    i18n: {
      messages: true,
    },
  },
})(NotificationAlert);
